import React from 'react'
import AppTabPromotionFormPage from './AppTabPromotionFormPage'

export default function AppTabPromotion(props) {
    return <AppTabPromotionFormPage mode="edit" promotionId={props.match.params.promotionId} />
}
